import { type GuidanceSession } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

interface UpdateGuidanceSessionBody {
    notes?: string | null;
}

export const useUpdateGuidanceSession = requestBuilder.mutation<
    GuidanceSession,
    UpdateGuidanceSessionBody,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/guidance-session/${id}`,
    method: 'PATCH',
});
